import { BentoBrand, CompensationType } from "schemas/dashboard";

import { getDifferenceFromToday } from "utils/time";

export const getIconsCondition = (bentoBrand: BentoBrand) => {
  const addedWithinLastWeek =
    getDifferenceFromToday(bentoBrand?.createdAt) <= 7;
  const hasPaidPartnership = bentoBrand?.hasValidatedPartnership;
  const worksWithUgc = bentoBrand?.worksWithUgc;
  const worksWithInfluencer = bentoBrand?.worksWithInfluencer;
  const noRecentContacts = bentoBrand?.contactedRecentlyAmount === 0;
  const hasTiktokAds = !!bentoBrand?.hasTiktokAds;
  const worksWithPodcasters = bentoBrand?.worksWithPodcasters;
  const hasNonGenericEmails = !!bentoBrand?.hasNonGenericContacts;
  const hasAds = !!bentoBrand?.hasAds;

  return {
    addedWithinLastWeek,
    hasPaidPartnership,
    worksWithUgc,
    worksWithInfluencer,
    worksWithPodcasters,
    noRecentContacts,
    hasTiktokAds,
    hasNonGenericEmails,
    hasAds,
  };
};

export const getVerifiedPartnershipData = (bentoBrand: BentoBrand) => {
  const verifiedInformation = [];

  if (bentoBrand.compensationTypes?.includes(CompensationType.cash)) {
    verifiedInformation.push("Offers paid collaborations with creators");
  }

  if (
    bentoBrand.compensationTypes?.includes(
      CompensationType.products_or_services,
    )
  ) {
    verifiedInformation.push("Sends gifted products or services to creators");
  }

  if (
    bentoBrand.compensationTypes?.includes(CompensationType.affiliate) ||
    bentoBrand.compensationTypes?.includes(CompensationType.tiktok_shop)
  ) {
    if (
      bentoBrand.compensationTypes.includes(CompensationType.affiliate) &&
      bentoBrand.compensationTypes.includes(CompensationType.tiktok_shop)
    ) {
      verifiedInformation.push(
        "Partners with creators through TikTok Shop and affiliate marketing",
      );
    } else if (
      bentoBrand.compensationTypes.includes(CompensationType.tiktok_shop)
    ) {
      verifiedInformation.push("Partners with creators through TikTok Shop");
    } else {
      verifiedInformation.push(
        "Partners with creators through affiliate marketing",
      );
    }
  }

  if (
    bentoBrand.worksWithProfileTypes &&
    bentoBrand.worksWithProfileTypes.length > 0
  ) {
    verifiedInformation.push(
      `Works with: ${bentoBrand.worksWithProfileTypes.join(", ")}`,
    );
  }

  return verifiedInformation;
};

export const displayPartnershipData = () => {};
